module.exports = __webpack_public_path__ + "img/18.81cb4734.jpg";